import { camelize } from '@ember/string';
import { StatusResponse } from '@square/dashboard-protos/models/squareup/multipass/http';

/**
 * This function does not recursively camelize nested object values.
 * This is a helper function specify for `fetchStatus` since the response body
 * keys needs to be camelized to be deserialized into a StatusResponse.
 *
 * Please do not use this function outside this module.
 */
const camelizeJsonKeys = json => Object.entries(json).reduce((collected, [key, value]) => {
  collected[camelize(key)] = value;
  return collected;
}, {});
export default async function () {
  const response = await fetch('/mp/status');
  if (!response.ok) {
    const error = new Error('Problem getting multipass status');
    throw Object.assign(error, {
      rawResponse: response
    });
  }
  const body = await response.json();
  return StatusResponse.fromObject(camelizeJsonKeys(body));
}